import { render, staticRenderFns } from "./AjaxErrors.vue?vue&type=template&id=617d0bf1&"
import script from "./AjaxErrors.vue?vue&type=script&lang=js&"
export * from "./AjaxErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports